/*@flow*/
import type { Node } from 'react';
import { createElement } from 'react';
import NumberT from 'lib/t/Number';
import type { ComponentPropsT } from '../types';
import getTemplate from '../util/getTemplate';
import { getPlaceholder } from '../util';
import getTransformer from '../util/getTransformer';
import { useField, useLocals } from '../hooks';

export default function TextboxComponent(props: ComponentPropsT): Node {
  const { path } = props;
  const { fieldOptions, typeInfo } = useField(path);
  const transName = typeInfo.innerType === NumberT ? 'number' : 'text';
  const transformer = getTransformer(fieldOptions, transName);
  let { attrs, ...locals } = useLocals(path, { transformer });
  const placeholder = getPlaceholder(fieldOptions);
  attrs = { ...attrs, placeholder };
  const type = fieldOptions.type || 'text';
  const template = getTemplate(fieldOptions, 'textbox');
  return createElement(template, { ...locals, type, attrs });
}
